const global={
  upvideopath:'http://192.168.1.3:81/prod-api',//必须配置生产环境接口地址
  needupface:false,
  paperfileapi:'/prod-api/' //生成环境"/prod-api/",
}
export default global;



//////////////////
// WEBPACK FOOTER
// ./static/gloabvar.js
// module id = null
// module chunks = 